import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { HttpClientModule } from '@angular/common/http';
import { IconToggleGroupComponent } from './icon-toggle-group.component';
import { TooltipModule } from '../../directives/tooltip';

@NgModule({
	imports: [
		CommonModule,
		HttpClientModule,
		TooltipModule,
	],
	exports: [IconToggleGroupComponent],
	declarations: [IconToggleGroupComponent],
	providers: [],
})
export class IconToggleGroupModule { }
